import React, { useEffect, useState, useRef } from 'react';
import GoogleMapReact from 'google-map-react';
import PUIcon from "../../assets/Images/MapImages/PUMarker.png";
import CompletedIcon from "../../assets/Images/MapImages/MarkerCompleted.png";
import UnroutedMarkerIcon from "../../assets/Images/MapImages/UnRoutedMarker.png";
import UnroutedMarkerDOIcon from "../../assets/Images/MapImages/UnRoutedMarkerDO.png";
import CabOffline from "../../assets/Images/MapImages/Cab_Offline.png";
import CabDisconnected from "../../assets/Images/MapImages/Cab_Disconnected.png";
import LiftOccupied from "../../assets/Images/MapImages/Lift_OCCUPIED.png";
import LiftOnline from "../../assets/Images/MapImages/Lift_ONLINE.png";
import SedanOccupied from "../../assets/Images/MapImages/Sedan_OCCUPIED.png";
import SedanOnline from "../../assets/Images/MapImages/Sedan_Online.png";
import VanOccupied from "../../assets/Images/MapImages/VAN_OCCUPIED.png";
import VanOnline from "../../assets/Images/MapImages/VAN_ONLINE.png";
import DepotIcon from "../../assets/Images/MapImages/depotIconBtn.png";
import ZoneIcon from "../../assets/Images/MapImages/zonesIcon.png";
import ZoomLockIcon from "../../assets/Images/MapImages/zoomLockIcon.png";
import nullifyIcon from "../../assets/Images/MapImages/nullifyMapIcon.png";
import RouteRemovalIcon from "../../assets/Images/MapImages/routeDelIcon.png";
import SDepot from "../../assets/Images/MapImages/StartDepotIcon.png";
import EDepot from "../../assets/Images/MapImages/EndDepotIcon.png";
import APICom from "../../utils/helpers/APICom";
import DispatchAction from '../Dispatch/DispatchAction';
import { useSelector } from "react-redux";
import OverlappingMarkerSpiderfier from 'overlapping-marker-spiderfier';
import {Col} from 'react-bootstrap';

const MapControl = (props = {}) => {
    const { ASCSSettingData } = useSelector((store) => store.combinedata); 
    const selectedAff = useRef(props.selectedAffiliates); const selectedDate = useRef(props.selectedDate);
    let startCenterLat = selectedAff.current && ASCSSettingData[selectedAff.current] ? (JSON.parse(ASCSSettingData[selectedAff.current]).find((item)=>item.SubTitle === "Default-Latitude-To-Focus-On-Zone-Management")).value: 39.16552683625823;
    let startCenterLng = selectedAff.current && ASCSSettingData[selectedAff.current] ?  (JSON.parse(ASCSSettingData[selectedAff.current]).find((item)=>item.SubTitle === "Default-Longitude-To-Focus-On-Zone-Management")).value: -77.16834351718929;
    const [zoomOpt, setZoomOpt] = useState({zoomControl: true, draggable: true, scrollWheel: true, disableDoubleClickZoom: false});
    const mapCenterRef = useRef({lat:parseFloat(startCenterLat),lng:parseFloat(startCenterLng)});
    const ITCMapURL = selectedAff.current && ASCSSettingData[selectedAff.current] ? 
    (JSON.parse(ASCSSettingData[selectedAff.current]).find((item)=>item.SubTitle === "ITCMapServiceURL")).value:"http://itcmap.itcurves.us/api/Map/";
    const OSRM_Username = selectedAff.current && ASCSSettingData[selectedAff.current] ? 
    (JSON.parse(ASCSSettingData[selectedAff.current]).find((item)=>item.SubTitle === "ITCMapServiceUserName")).value:"annapolis";
    const OSRM_Password = selectedAff.current && ASCSSettingData[selectedAff.current] ? 
    (JSON.parse(ASCSSettingData[selectedAff.current]).find((item)=>item.SubTitle === "ITCMapServicePassword")).value:"barwoodpass";
    const { loginData } = useSelector((store) => store.login);
    let state = {
        center: {lat:39.16552683625823, lng:-77.16834351718929},//{lat:39.16552683625823, lng:-77.16834351718929}, // IT Curves coordinates
        zoom: 8,
        tilt: 47.5,
        mapheight: props.options.mapHeight,
        heightoffset: 183,
        mapId: "90f87356969d889c",
        options: {
            gestureHandling: 'greedy',
            zoomControl: zoomOpt.zoomControl,
            draggable: zoomOpt.draggable,
            scrollWheel: zoomOpt.scrollWheel,
            disableDoubleClickZoom: zoomOpt.disableDoubleClickZoom,
        },
        places: props.MapDetailData,
    };
    
    state = {...state, ...props.options};
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    const [dynamicHeight, setMapDivHeight] = useState({});
    const [GlobalMapsObjects, setGlobalMapsObjects] = useState({});
    
    const [markers, setMarkers] = useState([]);
    const [depotMarkers, setDepotMarkers] = useState([]);
    const [depotInfo, setDepotInfo] = useState([]);
    const [PolyPaths, setPolyPaths] = useState([]);
    const [MapPopoutCreated, setMapPopoutCreated] = useState(false);
    const [showDepotSelected, setShowDepotSelected] = useState(false);
    const [routeRemovalCreated, setRouteRemovalCreated] = useState(false);
    const [MapZoomCreated, setMapZoomCreated] = useState(false);
    const [MapZoneCreated, setMapZoneCreated] = useState(false);
    const [MapInfoDivCreated, setMapInfoDivCreated] = useState(false);
    const [MapDepotCreated, setMapDepotCreated] = useState(false);
    const [MapMarkerRemovalCreated, setMapMarkerRemovalCreated] = useState(false);
    const [vehicleTableCreated, setvehicleTableCreated] = useState(false);
    const [infowindows, setinfowindows] = useState([]);
    const [invokeDispatchComponent, setinvokeDispatchComponent] = useState(false);
    const [dispatchVehicleID, setDispatchVehicleID] = useState(-1);
    const [dispatchDriverID, setDispatchDriverID] = useState(-1);
    const { AffiliateData } = useSelector((store) => store.combinedata);
    const addedUnroutedTrip = useRef(null);
    const singleClickUnroutedTrips = useRef(null);
    const additionalTrip = useRef([]);
    const keepZoneRef = useRef(false);
    const clusterTripsChangeRef = useRef([]);
    const routeLinesRef = useRef([]);
    const singleRoutePolylineRef = useRef([]);
    const originalInfoRef = useRef("");
    const [MapPreviousInfoDivCreated, setMapPreviousInfoDivCreated] = useState(false);
    let polygons = [];
    let vehImage = [];
    // let newClusterTripSet = [];

    useEffect(() => {
        // Call the function when currentState changes and previousState is not null
        if (props.clusterTableStateBeforeCompute) {
            const infoDivPrevious = createMapInfoDivPrevious(GlobalMapsObjects.map, GlobalMapsObjects.maps, props.clusterTableStateBeforeCompute, [])
            if(MapPreviousInfoDivCreated)
            {
                setMapInfoDivCreated(false);
                
                if(GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].length > 0)
                {
                    GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].removeAt(0);
                    GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].push(infoDivPrevious);
                    setMapPreviousInfoDivCreated(true);
                }
            }
            else{
                setMapInfoDivCreated(false);
                if(GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].length > 0)
                {
                    GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].removeAt(0);
                }
                GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].push(infoDivPrevious);
                setMapPreviousInfoDivCreated(true);

            }
            
            
        }
        else{
            if(MapPreviousInfoDivCreated)
            {
                
                setMapPreviousInfoDivCreated(false);
                if(GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].length > 0)
                {
                    GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].removeAt(0);
                }
                const infoDiv = createMapInfoDiv(GlobalMapsObjects.map, GlobalMapsObjects.maps, state.places, []);
                GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].push(infoDiv);
                setMapInfoDivCreated(true);
            }

        }
        
      }, [props.clusterTableStateBeforeCompute]);
    
    useEffect( ()=>{
        try{
            if(typeof GlobalMapsObjects.map !== 'undefined' && props.arrangedTripsClusterData.length > 0){
                clusterTripsChangeRef.current = [];
                for(var k = 0; k < props.arrangedTripsClusterData.length; k++)
                {
                    let mapInfo = null;
                    let eta = null;
                    if(props.arrangedTripsClusterData[k].Type === "PU")
                    {
                        mapInfo = new GlobalMapsObjects.maps.LatLng(parseFloat(props.arrangedTripsClusterData[k].dLatitude), parseFloat(props.arrangedTripsClusterData[k].dLongitude));
                        eta = (props.arrangedTripsClusterData[k].SchTime === ""? props.arrangedTripsClusterData[k].ReqTime:props.arrangedTripsClusterData[k].SchTime);
                        clusterTripsChangeRef.current.push({trip:"P", latLng: mapInfo, time: eta});
                    }
                    else if(props.arrangedTripsClusterData[k].Type === "DO")
                    {
                        mapInfo = new GlobalMapsObjects.maps.LatLng(parseFloat(props.arrangedTripsClusterData[k].dLatitude), parseFloat(props.arrangedTripsClusterData[k].dLongitude));
                        eta = (props.arrangedTripsClusterData[k].SchTime === ""? props.arrangedTripsClusterData[k].ReqTime:props.arrangedTripsClusterData[k].SchTime);
                        clusterTripsChangeRef.current.push({trip:"D", latLng: mapInfo, time: eta});  
                    }
                    
                }
                if(PolyPaths.length > 0)
                {
                    for(let i = 0; i < PolyPaths.length; i++) {
                        PolyPaths[i].setMap(null);
                    }
                    if(singleRoutePolylineRef.current !== undefined && singleRoutePolylineRef.current.length > 0 && additionalTrip.current.length > 0)
                    {
                        singleRoutePolylineRef.current.forEach(item=>{
                            item.setMap(GlobalMapsObjects.map);
                            PolyPaths.push(item);
                        });
                        setPolyPaths(PolyPaths);
                    }
                    getStraightPolylines(clusterTripsChangeRef.current, GlobalMapsObjects.map, GlobalMapsObjects.maps);
                }
            }
        }
        catch(err){console.log(err);}
        
    },[props.arrangedTripsClusterData]);

    useEffect( ()=>{
        try{                
            // console.log("Went to routed trip", props.routedTrip,state.places.length);
            if(state.places.length > 0)
            {
                addedUnroutedTrip.current = props.routedTrip;
                if(addedUnroutedTrip.current)
                {
                    if(addedUnroutedTrip.current.data !== "" /*&& state.places[0].Route !== ""*/)
                    {
                        handleAddingNewTrip(addedUnroutedTrip.current.data);
                    }
                    else if(addedUnroutedTrip.current.data === "" && state.places[0].Route !== "" && markers.length > 0)
                    {
                        additionalTrip.current = [];
                        if(markers.length > 0 && markers[(markers.length-1)].label?.text?.length === 1){
                            for(let i = 0; i < markers.length; i++) {
                                if(i === (markers.length-1))
                                {
                                    markers[i].setMap(null);
                                }
                                else if(i === (markers.length-2))
                                {
                                    markers[i].setMap(null);
                                }
                            }
                            for(let i = 0; i < PolyPaths.length; i++) {
                                if(PolyPaths[i].strokeColor === "brown")
                                {
                                    PolyPaths[i].setMap(null);
                                }
                            }
                            
                        }
                    }
                }
            }
        }
        catch(err){console.log(err);}
        
    }, [props.routedTrip]);

    useEffect( ()=>{
        try{   
            addedUnroutedTrip.current = props.unroutedTrip;
            // console.log("Went to UMNrouted trip", props.unroutedTrip);
            if(state.places.length > 0)
            {
                
                if(addedUnroutedTrip.current)
                {
                    
                    if(addedUnroutedTrip.current.data !== "" /*&& state.places[0].Route === ""*/)
                    {
                        handleAddingNewTrip(addedUnroutedTrip.current.data);
                    }
                    else if(addedUnroutedTrip.current.data === "" && state.places[0].Route === "" && markers.length > 0)
                    {
                        additionalTrip.current = [];
                        if(markers.length > 0 && markers[(markers.length-1)].label?.text?.length === 1){
                            for(let i = 0; i < markers.length; i++) {
                                if(i === (markers.length-1))
                                {
                                    markers[i].setMap(null);
                                }
                                else if(i === (markers.length-2))
                                {
                                    markers[i].setMap(null);
                                }
                            }
                            for(let i = 0; i < PolyPaths.length; i++) {
                                if(PolyPaths[i].strokeColor === "brown")
                                {
                                    PolyPaths[i].setMap(null);
                                }
                            }
                            
                        }
                    }
                }
            }
            else
            {
                // console.log(props.unroutedTrip);
                singleClickUnroutedTrips.current = props.unroutedTrip;
                if(singleClickUnroutedTrips.current?.data !== "")
                {
                    handleAddingNewTrip(singleClickUnroutedTrips.current.data);
                }
                else if(singleClickUnroutedTrips.current?.data === "")
                {
                    additionalTrip.current = [];
                    RemoveAllMapObjects();
                    props.setDetailDataFunc([]);
                    if(typeof GlobalMapsObjects.map !== 'undefined')
                    {
                        GlobalMapsObjects.map.setCenter(mapCenterRef.current);
                        GlobalMapsObjects.map.setZoom(state.zoom);
                    } 
                }
            }
        }
        catch(err){console.log(err);}
        
    }, [props.unroutedTrip]);

    useEffect( () => {
        if(typeof GlobalMapsObjects.map !== 'undefined'){
            clusterTripsChangeRef.current = [];
            if(routeRemovalCreated)
            {
                if(GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_BOTTOM].length > 0)
                {
                    GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_BOTTOM].removeAt(2);
                }
                const routeRemDiv = document.createElement("div");
                const routeRemDivBtn = createRouteRemovalBtn(GlobalMapsObjects.map, GlobalMapsObjects.maps);
                routeRemDiv.style.margin = "10px"; 

                routeRemDiv.append(routeRemDivBtn);
                GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_BOTTOM].push(routeRemDiv);
            }
            routeLinesRef.current = state.places;
            handleApiLoaded(GlobalMapsObjects.map, GlobalMapsObjects.maps, state.places);
        }
    }, [props.MapDetailData]);

    useEffect( () => {
        if(props.SelectedStopsData.length>1){
            if(typeof GlobalMapsObjects.map !== 'undefined'){
                clusterTripsChangeRef.current = [];
                if(routeRemovalCreated)
                {
                    if(GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_BOTTOM].length > 0)
                    {
                        GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_BOTTOM].removeAt(2);
                    }
                    const routeRemDiv = document.createElement("div");
                    const routeRemDivBtn = createRouteRemovalBtn(GlobalMapsObjects.map, GlobalMapsObjects.maps);
                    routeRemDiv.style.margin = "10px"; 
    
                    routeRemDiv.append(routeRemDivBtn);
                    GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_BOTTOM].push(routeRemDiv);
                }
                routeLinesRef.current = state.places;
                handleApiLoaded(GlobalMapsObjects.map, GlobalMapsObjects.maps, props.SelectedStopsData);
            }

           

        }

        else{

            if(typeof GlobalMapsObjects.map !== 'undefined'){
                clusterTripsChangeRef.current = [];
                if(routeRemovalCreated)
                {
                    if(GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_BOTTOM].length > 0)
                    {
                        GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_BOTTOM].removeAt(2);
                    }
                    const routeRemDiv = document.createElement("div");
                    const routeRemDivBtn = createRouteRemovalBtn(GlobalMapsObjects.map, GlobalMapsObjects.maps);
                    routeRemDiv.style.margin = "10px"; 
    
                    routeRemDiv.append(routeRemDivBtn);
                    GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_BOTTOM].push(routeRemDiv);
                }
                routeLinesRef.current = state.places;
                handleApiLoaded(GlobalMapsObjects.map, GlobalMapsObjects.maps, state.places);
            }

        }
       
    }, [props.SelectedStopsData]);

    useEffect( ()=>{
        if(typeof GlobalMapsObjects.map !== 'undefined'){
            try 
            {
                props.handleMapHeight(100);
                clusterTripsChangeRef.current = [];
                selectedAff.current = props.selectedAffiliates;
                selectedDate.current = props.selectedDate;
                startCenterLat =  selectedAff.current && ASCSSettingData[selectedAff.current] ? (JSON.parse(ASCSSettingData[selectedAff.current]).find((item)=>item.SubTitle === "Default-Latitude-To-Focus-On-Zone-Management")).value:39.16552683625823;
                startCenterLng =  selectedAff.current && ASCSSettingData[selectedAff.current] ? (JSON.parse(ASCSSettingData[selectedAff.current]).find((item)=>item.SubTitle === "Default-Longitude-To-Focus-On-Zone-Management")).value:-77.16834351718929;
                mapCenterRef.current = {lat:parseFloat(startCenterLat),lng:parseFloat(startCenterLng)};
                // GlobalMapsObjects.map.setCenter(mapCenterRef.current);
                let depotSection = document.getElementsByClassName("depotBtn")[0];
                if(showDepotSelected)
                {
                    depotSection.click();
                    depotSection.click();
                }
                
                let zones_elem_btn = document.getElementsByClassName("zones_btn")[0];
                zones_elem_btn.click();
                zones_elem_btn.click();
                RemoveAllMapObjects();
                props.setDetailDataFunc([]);
                GlobalMapsObjects.map.setCenter(mapCenterRef.current);
                GlobalMapsObjects.map.setZoom(state.zoom);
                if(MapInfoDivCreated)
                {
                    setMapInfoDivCreated(false);
                    if(GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].length > 0)
                    {
                        GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.TOP_LEFT].removeAt(0);
                    }
                }
                if(routeRemovalCreated)
                {
                    setRouteRemovalCreated(false);
                    if(GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_BOTTOM].length > 0)
                    {
                        GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_BOTTOM].removeAt(2);
                    }
                }
                if(vehicleTableCreated)
                {
                    setvehicleTableCreated(false);
                    if(GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_TOP].length > 0)
                    {
                        GlobalMapsObjects.map.controls[GlobalMapsObjects.maps.ControlPosition.LEFT_TOP].removeAt(0);
                    }
                }
            }
            catch (err) {console.log(err);}
        }
    },[props.selectedAffiliates, props.selectedDate]);

    useEffect(()=>{
        try{
            if(GlobalMapsObjects.map !== undefined && props.clusterTripSelected !== null && markers.length > 0)
            {
                for(let i = 0; i < markers.length; i++)
                {
                    if(markers[i].label?.name === props.clusterTripSelected.Number)
                    {
                        markers[i].setAnimation(GlobalMapsObjects.maps.Animation.BOUNCE);
                        stopAnimation(markers[i]);
                    }
                    else
                    {
                        markers[i].setAnimation(null);
                    }
                }
            }
        }
        catch(err){console.log(err);}
        
    }, [props.clusterTripSelected]);

    function stopAnimation(marker)
    {
        setTimeout(() => {
            marker.setAnimation(null);
        }, 3000);
    }

    function convertToMilitaryTime(inputTime) {
        const normalizedInput = inputTime.replace(/\s+/g, ' ');
        const [datePart, timeWithMeridian] = normalizedInput.split(' ');

        const [month, day, year] = datePart.split('/');
    
        const meridian = timeWithMeridian.slice(-2);
        const timePart = timeWithMeridian.slice(0, -2);
    
        let [hours, minutes] = timePart.split(':');
    
        if (hours === '12') hours = '0'; // Convert '12AM' to '00'
        if (meridian.toUpperCase() === 'PM' && hours !== '12') {
            hours = parseInt(hours, 10) + 12; // Convert PM hours to military time
        }
    
        hours = hours.toString().padStart(2, '0');
        minutes = minutes.padStart(2, '0');
    
        return `${hours}:${minutes}`;
    }

    const handleAddingNewTrip = async(data)=>{
        try{
            additionalTrip.current = [];
            let dict = {};
            let Nodes = [];
            if(data.length === 1)
            {
                Nodes = [];
                let PUNode = {
                    "TripNo": data[0].ConfirmationNo,
                    "PUPerson": data[0].PickupPerson,
                    "SchTime": convertToMilitaryTime(data[0].PickupDateTime),
                    "Type": "PU",
                    "dLatitude": data[0].PickupLatitude,
                    "dLongitude":data[0].PickupLongitude,
                    "vAddress": data[0].PickupAddress
                };
                let DONode = {
                    "TripNo": data[0].ConfirmationNo,
                    "PUPerson": data[0].PickupPerson,
                    "SchTime": '',
                    "Type": "DO",
                    "dLatitude": data[0].DropLatitude,
                    "dLongitude":data[0].DropLongitude,
                    "vAddress": data[0].Destination
                };
                Nodes.push(PUNode);
                Nodes.push(DONode);
                // let params = {
                //     "vManifestNumber": data[0].vManifestNumber,
                //     "dtSelectedDate": String(data[0].PickupDateTime.split(" ")[0]), //"12/06/2023" data[0].PickupDateTime.split(" ")[0],
                //     "vehicleId": -1,
                //     "bIncludePerformed": false,
                //     "vAffIDs": String(data[0].PrimaryAffiliateID), //String(data[0].PrimaryAffiliateID)
                //     "confirmationNo": String(data[0].ConfirmationNo),
                //     "iFetchMode": 1,
                //     "GridName": "SelectedGridRouteSRQARQPRQ_NewC",
                //     "iUserID": loginData.iUserID
                // }
                // let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetRouteStopView", "post", { "Content-Type": "application/json" }, params,  null);
                // let result = response.data;
                // if(result.data && result.data.length > 0)
                // {
                //     dict.trip = result.data;
                //     additionalTrip.current.push(dict);
                //     if(typeof GlobalMapsObjects.map !== 'undefined'){
                //         handleApiLoaded(GlobalMapsObjects.map, GlobalMapsObjects.maps, state.places);
                //     }
                // }
                // else
                // {
                //     console.log("bust");
                // }
                dict.trip = Nodes;
                additionalTrip.current.push(dict);
                if(typeof GlobalMapsObjects.map !== 'undefined'){
                    handleApiLoaded(GlobalMapsObjects.map, GlobalMapsObjects.maps, state.places);
                }
            }
            else if(data.length > 1)
            {
                let tempArr = [];
                let Nodes = [];
                let trips = [];
                additionalTrip.current = [];
                for(let y = 0; y < data.length; y++)
                {
                    dict = {};
                    Nodes = [];
                    let PUNode = {
                        "TripNo": data[y].ConfirmationNo,
                        "PUPerson": data[y].PickupPerson,
                        "SchTime": convertToMilitaryTime(data[y].PickupDateTime),
                        "Type": "PU",
                        "dLatitude": data[y].PickupLatitude,
                        "dLongitude":data[y].PickupLongitude,
                        "vAddress": data[y].PickupAddress
                    };
                    let DONode = {
                        "TripNo": data[y].ConfirmationNo,
                        "PUPerson": data[y].PickupPerson,
                        "SchTime": '',
                        "Type": "DO",
                        "dLatitude": data[y].DropLatitude,
                        "dLongitude":data[y].DropLongitude,
                        "vAddress": data[y].Destination
                    };
                    Nodes.push(PUNode);
                    Nodes.push(DONode);
                    trips.push(Nodes);
                    // let params = {
                    //     "vManifestNumber": data[y].vManifestNumber,
                    //     "dtSelectedDate": String(data[y].PickupDateTime.split(" ")[0]), //"12/06/2023" data[0].PickupDateTime.split(" ")[0],
                    //     "vehicleId": -1,
                    //     "bIncludePerformed": false,
                    //     "vAffIDs": String(data[y].PrimaryAffiliateID), //String(data[0].PrimaryAffiliateID)
                    //     "confirmationNo": String(data[y].ConfirmationNo),
                    //     "iFetchMode": 1,
                    //     "GridName": "SelectedGridRouteSRQARQPRQ_NewC",
                    //     "iUserID": loginData.iUserID
                    // }

                    // let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetRouteStopView", "post", { "Content-Type": "application/json" }, params,  null);
                    // let result = response.data;
                    
                    // if(result.data && result.data.length > 0)
                    // {
                    //     tempArr.push(result.data);
                        
                    // }
                    // else
                    // {
                    //     console.log("bust");
                    // }
                }
                dict.trips = trips;
                additionalTrip.current.push(dict);
                if(typeof GlobalMapsObjects.map !== 'undefined'){
                    handleApiLoaded(GlobalMapsObjects.map, GlobalMapsObjects.maps, state.places);
                }
            }
        }
        catch(err){console.log(err);}
    };

    const handleResize = () => {
        setWindowHeight(window.innerHeight);
    };

    const getInfoWindowString = (place, type, single_vehicle=false) => {
        let common_info = ""
        if (type === 'PU') {
            common_info += `
              <div>
                <div class="text-start">
                  <b class="fw-bold">Rider:</b> ${place.PUPerson} <br>
                  <b class="fw-bold">Address:</b> ${place.vAddress} <br>
                  <b class="fw-bold">Scheduled Pickup:</b> ${place.SchTime}
                </div>
              </div>`;
        } else if (type === 'DO') {
            common_info += `
              <div>
                <div class="text-start">
                  <b class="fw-bold">Rider:</b> ${place.PUPerson} <br>
                  <b class="fw-bold">Address:</b> ${place.vAddress} <br>
                  <b class="fw-bold">Scheduled Dropoff:</b> ${place.SchTime}
                </div>
              </div>`;
        }
        else if(type === 'Depot'){
            common_info += `
              <div>
                <div class="text-start">
                  <b class="fw-bold">Depot Name:</b> ${place.PUPerson} <br>
                  <b class="fw-bold">Address:</b> ${place.vAddress} <br>
                  <b class="fw-bold">Vehicle Info:</b> ${place.VehicleInfo}
                </div>
              </div>`;
        }
        else {
            if (single_vehicle) {
                common_info += `
                <div>
                  <div class="text-start">
                  <b class="fw-bold float-left">Vehicle #: </b>${place['VEH#']} <b class="fw-bold float-right" >Driver #:<b class="fw-light">${place['AssignedDriver#']}</b></b> <br>
                  <b class="fw-bold">State:</b> ${(place.TripRequestStatus === undefined || place.TripRequestStatus === null?"N/A":place.TripRequestStatus)} <br>
                  <b class="fw-bold">VehicleInfo:</b> ${(place.VTYPE===undefined || place.VTYPE === null?"N/A":place.VTYPE) + " " + place.VehicleInfo} <br>
        <!--          <b class="fw-bold">ETA:</b> ${"(" + place.dEstimateDistance + " Miles)"} <br>-->
                  </div>
                </div>`;
            }
            else {
                let driver_no = place.AssignedDriver;
                common_info += `
                <div>
                  <div class="text-start">
                  <b class="fw-bold float-left">Vehicle #: </b>${place.VehNo} <b class="fw-bold float-right" >Driver #:<b class="fw-light">${place.DriverNo}</b></b> <br>
                  <b class="fw-bold">State:</b> ${place.STATE} <br>
                  <b class="fw-bold">VehicleInfo:</b> ${place.VehMake + "("+place.VehicleMake+")"} <br>
                  <b class="fw-bold">ETA:</b> ${"("+place.Distance +" Miles)"} <br>
                  </div>
                </div>`;
            };
        }
        return common_info;
    }

    const getMapBounds = (map, maps, places, itemsInArray) => {
        try{
            const bounds = new maps.LatLngBounds();
            if(itemsInArray === "single")
            {
                if(places.length > 0)
                {
                    places.forEach((place) => {
                        if(places[0].dLatitude !== null && place.dLatitude !== "" && parseFloat(place.dLatitude) !== 0)
                        {
                            bounds.extend(new maps.LatLng(
                                parseFloat(place.dLatitude),
                                parseFloat(place.dLongitude),
                            ));
            
                            // bounds.extend(new maps.LatLng(
                            //     parseFloat(place.dLatitude),
                            //     parseFloat(place.dLongitude),
                            // ));
                        }
                        
                        
                    });
                }
            }
            else
            {
                if(places.length > 0)
                {
                    places.forEach((item) => {
                        item.forEach((place)=>{
                            bounds.extend(new maps.LatLng(
                                parseFloat(place.dLatitude),
                                parseFloat(place.dLongitude),
                            ));
            
                            // bounds.extend(new maps.LatLng(
                            //     parseFloat(place.dLatitude),
                            //     parseFloat(place.dLongitude),
                            // ));
                        });
                    });
                }
            }
            return bounds;

        }

        catch(err){console.log(err);}
        
    };

    const UnmountDispatchActionComponent = () =>{
        setinvokeDispatchComponent(false);
        props.GridRefresh();
        document.getElementById(state.GridName+"_vehMapDiv").style.display = 'none';
    }
    
    const getMapZones = (map, maps) => {
        let zoneDict = {};
        let zoneColorsDict = {};
        let selectedCompany = document.getElementsByClassName("form-select")[0].value;
        let selectedAff = 0;
        for(var i = 0; i < AffiliateData.length; i++){
            if(selectedCompany.indexOf(AffiliateData[i].DTSPID.toString()) > -1){
              selectedAff = parseInt(AffiliateData[i]["AffiliateID"]);
            }
        }
        for(let s = 0 ; s < props.zones.length; s++)
        {
            if(props.zones[s].iZVATSPID === selectedAff) //props.selectedAffiliates
            {
                let key = props.zones[s].vName;
                if(key in zoneDict)
                {
                    let zoneLocations = zoneDict[key];
                    let zoneColors = zoneColorsDict[key];
                    zoneColors = [{"vZoneColor": props.zones[s].vZoneColor}];
                    let tempDict = {"lat": parseFloat(props.zones[s].vLat), "lng": parseFloat(props.zones[s].vLong)};
                    zoneLocations.push(tempDict);
                    zoneDict[key] = zoneLocations;
                    zoneColorsDict[key] = zoneColors;
                }
                else
                {
                    let zoneLocations = [];
                    let zoneColors = [];
                    let tempDict = {"lat": parseFloat(props.zones[s].vLat), "lng": parseFloat(props.zones[s].vLong)};
                    zoneLocations.push(tempDict);
                    zoneColors = [{"vZoneColor": props.zones[s].vZoneColor}];
                    zoneDict[key] = zoneLocations;
                    zoneColorsDict[key] = zoneColors;
                }
            }

        }
        let counter = 0;
        for(let i in zoneDict)
        {
            polygons.push(new maps.Polygon({
                paths: zoneDict[i],
                strokeColor: "black",
                strokeOpacity: 0.3,
                strokeWeight: 2,
                fillColor: zoneColorsDict[i][0].vZoneColor,
                fillOpacity: 0.25,
                title: i
            }));
            polygons[counter].setMap(map);
            counter+=1;
        }
    };

    const getNearbyVehicles = () => {
        try{
            let vehData = props.vehData;
            if(state.places.length !== 0 && state.places !== null)
            {
                if (vehData.length === 1 && vehData.length !== 0 ) {
                    let veh_data = vehData[0];
                    if (veh_data.AssignedVehType.toUpperCase() === "VAN" || veh_data.AssignedVehType.toUpperCase() === "WAGON") {
                        if (veh_data.TripRequestStatus.toUpperCase() === "DISCONNECTED") {
                            vehImage.push(CabDisconnected);
                        } else if (veh_data.TripRequestStatus.toUpperCase() === "OCCUPIED" || veh_data.TripRequestStatus.toUpperCase() === "PICKEDUP") {
                            vehImage.push(VanOccupied);
                        } else if (veh_data.TripRequestStatus.toUpperCase() === "OFFLINE") {
                            vehImage.push(CabOffline);
                        } else if (veh_data.TripRequestStatus.toUpperCase() === "ACCEPTED" || veh_data.TripRequestStatus.toUpperCase() === "ONLINE" 
                            || veh_data.TripRequestStatus.toUpperCase() === "IRTPU" || veh_data.TripRequestStatus.toUpperCase() === "ATLOCATION") {
                            vehImage.push(VanOnline);
                        }
                    }
                    else {
                        if (veh_data.TripRequestStatus.toUpperCase() === "DISCONNECTED") {
                            vehImage.push(CabDisconnected);
                        } else if (veh_data.TripRequestStatus.toUpperCase() === "OCCUPIED" || veh_data.TripRequestStatus.toUpperCase() === "PICKEDUP") {
                            vehImage.push(SedanOccupied);
                        } else if (veh_data.TripRequestStatus.toUpperCase() === "OFFLINE") {
                            vehImage.push(CabOffline);
                        } else if (veh_data.TripRequestStatus.toUpperCase() === "ACCEPTED" || veh_data.TripRequestStatus.toUpperCase() === "ONLINE" 
                            || veh_data.TripRequestStatus.toUpperCase() === "IRTPU" || veh_data.TripRequestStatus.toUpperCase() === "ATLOCATION") {
                            vehImage.push(SedanOnline);
                        }
                    }
                }
                else {

                    for (var vehicle in vehData) {
                        if(vehData[vehicle].VehicleMake.toUpperCase() === "VAN" || vehData[vehicle].VehicleMake.toUpperCase() === "WAGON")
                        {
                            if(vehData[vehicle].STATE.toUpperCase() === "DISCONNECTED")
                            {
                                vehImage.push(CabDisconnected);
                            }
                            else if(vehData[vehicle].STATE.toUpperCase() === "OCCUPIED" || vehData[vehicle].STATE.toUpperCase() === "PICKEDUP")
                            {
                                vehImage.push(VanOccupied);
                            }
                            else if(vehData[vehicle].STATE.toUpperCase() === "OFFLINE")
                            {
                                vehImage.push(CabOffline);
                            }
                            else if(vehData[vehicle].STATE.toUpperCase() === "ONLINE" || vehData[vehicle].STATE.toUpperCase() === "IRTPU" || vehData[vehicle].STATE.toUpperCase() === "ATLOCATION")
                            {
                                vehImage.push(VanOnline);
                            }
                        }
                        else if(vehData[vehicle].VehicleMake.toUpperCase() === "VPG" || vehData[vehicle].VehicleMake.toUpperCase() === "LIFT")
                        {
                            if(vehData[vehicle].STATE.toUpperCase() === "OCCUPIED" || vehData[vehicle].STATE.toUpperCase() === "PICKEDUP")
                            {
                                vehImage.push(LiftOccupied);
                            }
                            else if(vehData[vehicle].STATE.toUpperCase() === "ONLINE" || vehData[vehicle].STATE.toUpperCase() === "IRTPU" || vehData[vehicle].STATE.toUpperCase() === "ATLOCATION")
                            {
                                vehImage.push(LiftOnline);
                            }
                            else if(vehData[vehicle].STATE.toUpperCase() === "DISCONNECTED")
                            {
                                vehImage.push(CabDisconnected);
                            }
                            else if(vehData[vehicle].STATE.toUpperCase() === "OFFLINE")
                            {
                                vehImage.push(CabOffline);
                            }
                        }
                        else
                        {
                            if(vehData[vehicle].STATE.toUpperCase() === "DISCONNECTED")
                            {
                                vehImage.push(CabDisconnected);
                            }
                            else if(vehData[vehicle].STATE.toUpperCase() === "OCCUPIED" || vehData[vehicle].STATE.toUpperCase() === "PICKEDUP")
                            {
                                vehImage.push(SedanOccupied);
                            }
                            else if(vehData[vehicle].STATE.toUpperCase() === "OFFLINE")
                            {
                                vehImage.push(CabOffline);
                            }
                            else if(vehData[vehicle].STATE.toUpperCase() === "ONLINE" || vehData[vehicle].STATE.toUpperCase() === "IRTPU" || vehData[vehicle].STATE.toUpperCase() === "ATLOCATION")
                            {
                                vehImage.push(SedanOnline);
                            }
                        }
                    }
                }
            }
            
        }
        catch(err){};
       
    };
    const createPopOutMapBtn = () =>{
        const controlButton = document.createElement("button");
        // Set CSS for the control.
        controlButton.style.color = "rgb(25,25,25)";
        controlButton.style.cursor = "pointer";
        controlButton.style.fontFamily = "Roboto,Arial,sans-serif";
        // controlButton.style.fontSize = "24px";
        controlButton.style.lineHeight = "38px";
        controlButton.style.margin = "10px 0 22px";
        controlButton.style.padding = "0 5px";
        controlButton.style.textAlign = "center";
        controlButton.textContent = "❐";
        controlButton.classList.add("shadow-sm", "border-0");
        controlButton.style.cssText = "font-size: 24px !important; width: 40px; height: 40px; background-color: #fff; border-radius: 3px; box-shadow: 0 2px 6px rgba(0,0,0,.3);";
        controlButton.title = "Map Page";
        controlButton.type = "button";
        controlButton.id = state.GridName+"_popOutMapBtn";
        // Setup the click event listeners: simply set the map to Chicago.
        controlButton.addEventListener("click", () => {
            let newWindow = window.open('/MapPage', '_blank');
            newWindow.MapDetailData = props.MapDetailData;
            props.handleMapMode(false);
            if(window.getComputedStyle(document.getElementById(state.GridName+'_mapViewBtn')).display === "block" && window.getComputedStyle(document.getElementById(state.GridName+"_container")).display === "block"){
                document.getElementById(state.GridName+'_mapViewBtn').textContent = "Map";
                document.getElementById(state.GridName+'_mapViewBtn').title = "Map View";
                document.getElementById(state.GridName+"_container").className ="col";
            }
        });
        return controlButton;
    }

    const createZoomMapBtn = () =>{
        const zoomButton = document.createElement("button");
        const zoomLockImage = document.createElement("img");
        zoomLockImage.src = ZoomLockIcon;
        zoomLockImage.style = "width:30px;height:30px; margin:auto";
        // Set CSS for the control.
        zoomButton.style.color = "rgb(25,25,25)";
        zoomButton.style.cursor = "pointer";
        zoomButton.style.fontFamily = "Roboto,Arial,sans-serif";
        // controlButton.style.fontSize = "24px";
        zoomButton.style.lineHeight = "38px";
        zoomButton.style.margin = "10px 0 22px";
        zoomButton.style.padding = "0 5px";
        zoomButton.style.textAlign = "center";
        // zoomButton.textContent = "Z";
        zoomButton.classList.add("shadow-sm", "border-0", "d-flex", "justify-content-center");
        zoomButton.style.cssText = "font-size: 24px !important; width: 40px; height: 40px; background-color: #fff; border-radius: 3px; box-shadow: 0 2px 6px rgba(0,0,0,.3);";
        zoomButton.title = "Lock Zoom";
        zoomButton.type = "button";
        zoomButton.id = state.GridName+"_zoomButtonMapBtn";
        // Setup the click event listeners: simply set the map to Chicago.
        zoomButton.addEventListener("click", () => {
            if(zoomButton.title === "Lock Zoom")
            {
                zoomButton.title = "Unlock Zoom";
                setZoomOpt({zoomControl: false, draggable: true, scrollWheel: false, disableDoubleClickZoom: true});
            }
            else if(zoomButton.title === "Unlock Zoom")
            {
                zoomButton.title = "Lock Zoom";
                setZoomOpt({zoomControl: true, draggable: true, scrollWheel: true, disableDoubleClickZoom: false});
            }
        });

        zoomButton.appendChild(zoomLockImage);

        return zoomButton;
    }
    const createMapInfoDiv = (map, maps, places, content) =>{
        const InfoDivCluster = document.createElement("div");
        let estMilesTot = 0;
        let estTimeTot = 0;
        let tripCount = 0;
        let passCount = [];
        for(let i = 0; i < places.length; i++)
        {
            estMilesTot+= parseFloat(places[i].EstDistFromPrev);
            estTimeTot+= parseFloat(places[i].EstTimeFromPrev);
            if(places[i].Type.toUpperCase() === "PU" || places[i].Type.toUpperCase() === "DO")
            {
                tripCount+=1;
                passCount.push(places[i].PUPerson);
            }
        }
        passCount = [...new Set(passCount)];
        tripCount = tripCount/2;
        // Set CSS for the control. 
        InfoDivCluster.style.color = "rgb(25,25,25)";
        InfoDivCluster.style.cursor = "default";
        InfoDivCluster.style.fontFamily = "Roboto,Arial,sans-serif";
        // InfoDivCluster.style.lineHeight = "38px";
        InfoDivCluster.style.margin = "10px 0 22px";
        InfoDivCluster.style.padding = "0 5px";
        InfoDivCluster.style.textAlign = "center";
        InfoDivCluster.textContent = (content.length === 0 ? "Original: Trips: "+tripCount+" | Est. Dist: "+estMilesTot.toFixed(2)+" mi | Est. Time: "+parseInt(estTimeTot)+" mins | Pax Count: "+passCount.length: 
        "Original: Trips: "+content[0]+" | Est. Dist: "+content[1].toFixed(2)+" mi | Est. Time: "+parseInt(content[2])+" mins | Pax Count: "+content[3] );
        InfoDivCluster.classList.add("shadow-sm", "border-dark", "user-select-none", "fw-bold", "p-1", "mt-3", "mapInfoTextDiv");
        InfoDivCluster.style.cssText = "font-size: small !important; text-wrap:balance; color:green; background-color: #fff; border-radius: 3px; box-shadow: 0 2px 6px rgba(0,0,0,.3);";
        InfoDivCluster.id = state.GridName+"_clusterInfoDiv";
        originalInfoRef.current = (content.length === 0 ? "Original: Trips: "+tripCount+" | Est. Dist: "+estMilesTot.toFixed(2)+" mi | Est. Time: "+parseInt(estTimeTot)+" mins | Pax Count: "+passCount.length: 
        "Original: Trips: "+content[0]+" | Est. Dist: "+content[1].toFixed(2)+" mi | Est. Time: "+parseInt(content[2])+" mins | Pax Count: "+content[3] );
        return InfoDivCluster;
    }

    const createMapInfoDivPrevious = (map, maps, griddata, content) =>{
        const InfoDivClusterPrevious = document.createElement("div");
        const InfoDivOrigInfo = document.createElement("p");
        let estMilesTot = 0;
        let estTimeTot = 0;
        let tripCount = 0;
        let passCount = [];
        for(let i = 0; i < griddata.length; i++)
        {
            estMilesTot+= parseFloat(griddata[i].EstDistFromPrev);
            estTimeTot+= parseFloat(griddata[i].EstTimeFromPrev);
            if(griddata[i].Type.toUpperCase() === "PU" || griddata[i].Type.toUpperCase() === "DO")
            {
                tripCount+=1;
                passCount.push(griddata[i].PUPerson);
            }
        }
        passCount = [...new Set(passCount)];
        tripCount = tripCount/2;
        // Set CSS for the control. 
        InfoDivClusterPrevious.style.color = "rgb(25,25,25)";
        InfoDivClusterPrevious.style.cursor = "default";
        InfoDivClusterPrevious.style.fontFamily = "Roboto,Arial,sans-serif";
        // InfoDivCluster.style.lineHeight = "38px";
        InfoDivClusterPrevious.style.margin = "4px0 0 450px";
        InfoDivClusterPrevious.style.padding = "0 5px";
        InfoDivClusterPrevious.style.textAlign = "center";
        InfoDivClusterPrevious.textContent = originalInfoRef.current;
        InfoDivClusterPrevious.classList.add("shadow-sm", "border-dark", "user-select-none", "fw-bold", "p-1", "mt-3", "mapInfoTextDiv");
        InfoDivClusterPrevious.style.cssText = "font-size: small !important; text-wrap:balance; color:green; background-color: #fff; border-radius: 3px; box-shadow: 0 2px 6px rgba(0,0,0,.3);";
        InfoDivClusterPrevious.id = state.GridName+"_clusterInfoDivPrevious";

        InfoDivOrigInfo.classList.add("border-dark", "user-select-none", "fw-bold", "p-1", "m-0", "mapInfoTextDivPrevious");
        InfoDivOrigInfo.style.cssText = "font-size: small !important; text-wrap:balance; color:#685c5c; background-color: #fff;";
        InfoDivOrigInfo.textContent = (content.length === 0 ? "New: Trips: "+tripCount+" | Est. Dist: "+estMilesTot.toFixed(2)+" mi | Est. Time: "+parseInt(estTimeTot)+" mins | Pax Count: "+passCount.length: 
            "New: Trips: "+content[0]+" | Est. Dist: "+content[1].toFixed(2)+" mi | Est. Time: "+parseInt(content[2])+" mins | Pax Count: "+content[3] );
        InfoDivClusterPrevious.appendChild(InfoDivOrigInfo);

        return InfoDivClusterPrevious;
    }

    const createRouteRemovalBtn = (map, maps) =>{
        const routeRemovalBtn = document.createElement("button");
        const routeRemovalImage = document.createElement("img");
        routeRemovalImage.src = RouteRemovalIcon;
        routeRemovalImage.style = "width:30px;height:35px; margin:auto";
        // Set CSS for the control.
        routeRemovalBtn.style.color = "rgb(25,25,25)";
        routeRemovalBtn.style.cursor = "pointer";
        routeRemovalBtn.style.fontFamily = "Roboto,Arial,sans-serif";
        routeRemovalBtn.style.lineHeight = "38px";
        routeRemovalBtn.style.margin = "10px 0 22px";
        routeRemovalBtn.style.padding = "0 5px";
        routeRemovalBtn.style.textAlign = "center";
        // routeRemovalBtn.textContent = "┊";
        routeRemovalBtn.classList.add("shadow-sm", "border-0", "d-flex", "justify-content-center");
        routeRemovalBtn.style.cssText = "font-size: 24px !important; width: 40px; height: 40px; background-color: #fff; border-radius: 3px; box-shadow: 0 2px 6px rgba(0,0,0,.3);";
        routeRemovalBtn.title = "Hide Routes";
        routeRemovalBtn.type = "button";
        routeRemovalBtn.id = state.GridName+"_routeRemovalMapBtn";
        routeRemovalBtn.addEventListener("click", async() => {
            if(routeRemovalBtn.title === "Hide Routes")
            {
                routeRemovalBtn.title = "Show Routes";
                for(let i = 0; i < PolyPaths.length; i++) {
                    PolyPaths[i].setMap(null);
                }

            }
            else if(routeRemovalBtn.title === "Show Routes")
            {
                let newRouteArray = [];
                routeRemovalBtn.title = "Hide Routes"; 
                if(clusterTripsChangeRef.current.length > 0)
                {
                    getStraightPolylines(clusterTripsChangeRef.current, GlobalMapsObjects.map, GlobalMapsObjects.maps);
                    if(singleRoutePolylineRef.current !== undefined && singleRoutePolylineRef.current.length > 0 && additionalTrip.current.length > 0)
                    {
                        singleRoutePolylineRef.current.forEach(item=>{
                            item.setMap(map);
                            PolyPaths.push(item);
                        });
                        setPolyPaths(PolyPaths);
                    }
                }
                else
                {
                    routeLinesRef.current.forEach((place)=>{
                        if(place.Type === "PU")
                        {
                            newRouteArray.push({trip:"P", latLng: new maps.LatLng(parseFloat(place.dLatitude),parseFloat(place.dLongitude)), time: place.SchTime });
                        }
                        else if(place.Type === "DO")
                        {
                            newRouteArray.push({trip:"D", latLng: new maps.LatLng(parseFloat(place.dLatitude),parseFloat(place.dLongitude)), time: place.SchTime });
                        }
                    });
                    if(singleRoutePolylineRef.current !== undefined && singleRoutePolylineRef.current.length > 0 && additionalTrip.current.length > 0)
                    {
                        singleRoutePolylineRef.current.forEach(item=>{
                            item.setMap(map);
                            PolyPaths.push(item);
                        });
                        setPolyPaths(PolyPaths);
                    }
                    getStraightPolylines(newRouteArray, map, maps);
                } 
            }
        });

        routeRemovalBtn.appendChild(routeRemovalImage);

        return routeRemovalBtn;
    }

    const createDepotBtn = (map, maps, places) =>{
        const depotButton = document.createElement("button");
        const depotImage = document.createElement("img");
        depotImage.src = DepotIcon;
        depotImage.style = "width:30px; height:35px; margin:auto";
        // Set CSS for the control.
        depotButton.style.color = "rgb(25,25,25)";
        depotButton.style.cursor = "pointer";
        depotButton.style.fontFamily = "Roboto,Arial,sans-serif";
        depotButton.style.lineHeight = "38px";
        depotButton.style.margin = "10px 0 22px";
        depotButton.style.padding = "0 5px";
        // depotButton.textContent = "D";
        depotButton.style.textAlign = "center";
        depotButton.classList.add("shadow-sm", "border-0", "depotBtn", "d-flex", "justify-content-center");
        depotButton.style.cssText = "font-size: 24px !important; width: 40px; height: 40px; background-color: #fff; border-radius: 3px; box-shadow: 0 2px 6px rgba(0,0,0,.3);";
        depotButton.title = "Show Depot";
        depotButton.type = "button";
        depotButton.id = state.GridName+"_depotButtonMapBtn";
        depotButton.addEventListener("click", async() => {
            if(depotButton.title === "Show Depot")
            {
                depotButton.title = "Hide Depot";
                setShowDepotSelected(true);
                handleAddDepot(map, maps);
            }
            else if(depotButton.title === "Hide Depot")
            {
                depotButton.title = "Show Depot";
                //removing depot points
                setShowDepotSelected(false);
                for(let i = 0; i < depotMarkers.length; i++) {
                    depotMarkers[i].setMap(null);
                }
                for(let i = 0; i < depotInfo.length; i++) {
                    depotInfo[i].setMap(null);
                }
            }
        });
        depotButton.appendChild(depotImage); 
        return depotButton;
    }

    const createMarkerRemovalBtn = (map, maps) =>{
        const nullifyButton = document.createElement("button");
        const nullifyImage = document.createElement("img");
        nullifyImage.src = nullifyIcon;
        nullifyImage.style = "width:30px; height:32px; margin:auto";
        // Set CSS for the control.
        nullifyButton.style.color = "rgb(25,25,25)";
        nullifyButton.style.cursor = "pointer";
        nullifyButton.style.fontFamily = "Roboto,Arial,sans-serif";
        nullifyButton.style.lineHeight = "38px";
        nullifyButton.style.margin = "10px 0 22px";
        nullifyButton.style.padding = "0 5px";
        nullifyButton.style.textAlign = "center";
        // nullifyButton.textContent = "☒";
        nullifyButton.classList.add("shadow-sm", "border-0", "d-flex", "justify-content-center");
        nullifyButton.style.cssText = "font-size: 24px !important; width: 40px; height: 40px; background-color: #fff; border-radius: 3px; box-shadow: 0 2px 6px rgba(0,0,0,.3);";
        nullifyButton.title = "Remove Trips From Map";
        nullifyButton.type = "button";
        nullifyButton.id = state.GridName+"_nullifyButtonMapBtn";
        nullifyButton.addEventListener("click", () => {
            try{
                props.setNullifyActivated(true);
                setRouteRemovalCreated(false);
                props.handleMapHeight(100);
                props.selectedTripInfoToRefreshGrid.current= null
                props.DropDownRouteValue.current= null
                if(map.controls[maps.ControlPosition.LEFT_BOTTOM].length === 3)
                {
                    map.controls[maps.ControlPosition.LEFT_BOTTOM].removeAt(2);
                }
                setMapInfoDivCreated(false);
                if(map.controls[maps.ControlPosition.TOP_LEFT].length > 0)
                {
                    map.controls[maps.ControlPosition.TOP_LEFT].removeAt(0);
                }
                setvehicleTableCreated(false);
                if(map.controls[maps.ControlPosition.LEFT_TOP].length > 0)
                {
                    map.controls[maps.ControlPosition.LEFT_TOP].removeAt(0);
                }
                keepZoneRef.current = true;
                RemoveAllMapObjects();
                props.setDetailDataFunc([]);
                map.setCenter(mapCenterRef.current);
                map.setZoom(state.zoom);
            }
            catch(err){console.log(err);}
        });

        nullifyButton.appendChild(nullifyImage);

        return nullifyButton;
    }

    const createZoneMapBtn = (map, maps) =>{
        const zoneButton = document.createElement("button");
        const zoneImage = document.createElement("img");
        zoneImage.src = ZoneIcon;
        zoneImage.style = "width:30px;height:35px";
        // Set CSS for the control.
        zoneButton.style.color = "rgb(25,25,25)";
        zoneButton.style.cursor = "pointer";
        zoneButton.style.fontFamily = "Roboto,Arial,sans-serif";
        // controlButton.style.fontSize = "24px";
        zoneButton.style.lineHeight = "38px";
        zoneButton.style.margin = "10px 0 22px";
        zoneButton.style.padding = "0 5px";
        zoneButton.style.textAlign = "center";
        zoneButton.classList.add("shadow-sm", "border-0", "zones_btn", "d-flex", "justify-content-center");
        zoneButton.style.cssText = "font-size: 24px !important; width: 40px; height: 40px; background-color: #fff; border-radius: 3px; box-shadow: 0 2px 6px rgba(0,0,0,.3);";
        zoneButton.title = "Show Zones";
        zoneButton.type = "button";
        zoneButton.id = state.GridName+"_zoomButtonMapBtn";
        // Setup the click event listeners: simply set the map to Chicago.
        zoneButton.addEventListener("click", () => {
            
            if(zoneButton.title === "Hide Zones")
            {
                zoneButton.title = "Show Zones";
                for(let i = 0; i < polygons.length; i++) {
                    polygons[i].setMap(null);
                }
                polygons = [];
            }
            else if(zoneButton.title === "Show Zones")
            {
                zoneButton.title = "Hide Zones";
                getMapZones(map, maps);
            }
            
            
        });
        zoneButton.appendChild(zoneImage);
        return zoneButton;
    }

    const createVehTreeTable = (map, maps) =>{
        const tableDiv = document.createElement("table");
        // Set CSS for the control.
        tableDiv.style.color = "rgb(25,25,25)";
        tableDiv.style.cursor = "pointer";
        tableDiv.style.fontFamily = "Roboto,Arial,sans-serif";
        // controlButton.style.fontSize = "24px";
        tableDiv.style.lineHeight = "38px";
        tableDiv.style.margin = "10px 0 22px";
        tableDiv.style.padding = "0 5px";
        tableDiv.style.textAlign = "center";
        tableDiv.classList.add("shadow-sm", "border-0");
        tableDiv.style.cssText = "font-size: 24px !important; width: 40px; height: 40px; background-color: #fff; border-radius: 3px; box-shadow: 0 2px 6px rgba(0,0,0,.3);";
        tableDiv.id = state.GridName+"_vehTableTree";

        return tableDiv;
    }

    const handleAddDepot = async(map, maps)=>{
        try{
            let params = {
                "dtServiceDate": selectedDate.current,
                "vAffID": selectedAff.current, //"12/06/2023",
                "iSettingID": "-1",
            };
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetAllDepots", "post", { "Content-Type": "application/json" }, params,  null);
            let result = response.data;
            if(result.length > 0)
            {
                try{
                    for(let y = 0; y < result.length; y++)
                    {
                        depotMarkers.push(new maps.Marker({
                            position: {
                            lat: parseFloat(result[y].DepotLatitude),
                            lng: parseFloat(result[y].DepotLongitude),
                            },
                            map,
                            icon: "https://maps.gstatic.com/mapfiles/ms2/micons/homegardenbusiness.png",
                        }));
                        depotInfo.push(new maps.InfoWindow({
                            content: `<div>
                            <div class="text-start">
                            <b class="fw-bold float-left">Depot Name: </b>${result[y].DepotName} <br>
                            <b class="fw-bold">Address: </b> ${result[y].DepotAddress} <br></div>
                        </div>`,
                        }));
                        // bounds.extend(new maps.LatLng(
                        //     parseFloat(result[y].DepotLatitude),
                        //     parseFloat(result[y].DepotLongitude),
                        // ));
                    }
                    depotMarkers.forEach((marker, i)=>{
                        marker.addListener('mouseover', () => {
                            depotInfo[i].open(map, marker);
                        });
                        marker.addListener("mouseout", () => {
                            depotInfo[i].close();
                        });
                    });
                    setDepotMarkers(depotMarkers);
                    setDepotInfo(depotInfo);
                    
                }
                catch(err){console.log(err);}
            }
            else
            {
                console.log("no depot given");
            }
        }
        catch(err){console.log(err);}
    }
    
    const handleApiLoaded = (map, maps, places) => {
        try{
            keepZoneRef.current = false;
            if(props.sidebarStatus)
            {
                let mapContainer = document.getElementById(props.options.GridName +'_mapContainer');
                let clusterContainer = document.getElementById("clusterTableGrid_container");
                let gridContainer = document.getElementById(props.options.GridName+"_container");
                if(!gridContainer.classList.contains('gridOpenMapStyle')){gridContainer.classList.add('gridOpenMapStyle');}
                if(!state.mapClass.includes("mapOpenStyle")){mapContainer.classList.add("mapOpenStyle");}
                if(!clusterContainer.classList.contains("mapOpenStyle")){clusterContainer.classList.add("mapOpenStyle");}
            }
            RemoveAllMapObjects();
            let oms = new OverlappingMarkerSpiderfier(map, {
                markersWontMove: true,
                markersWontHide: true,
                spiderfiedShadowColor: false,
                nudgeStackedMarkers: false,
            });
            let newPathArray = [];
            if(state.mapheight === "auto") { 
                let newHeight = windowHeight - state.heightoffset;
                
                if(window.getComputedStyle(document.getElementById("clusterTableGrid_container")).display === "block" && document.getElementById(props.options.GridName+'_mapViewBtn').textContent.toUpperCase() === "BACK")
                {
                    setTimeout(() => {
                        try{
                            newHeight = newHeight - document.getElementById("clusterTableGrid_container").offsetHeight;
                        
                            setMapDivHeight({height:newHeight});
                        }
                        catch(err){console.log(err);}
                        
                    }, 500);
                }
                else
                {
                    setMapDivHeight({height:newHeight});
                }
                // setMapDivHeight({height: newHeight+"px"}); 
                
            }
            else
            {
                setMapDivHeight({height: state.mapheight})
            }
            
            
            getNearbyVehicles();
            // Create the DIV to hold the control.
            // if(MapPopoutCreated === false){
            //     const ControlDiv = document.createElement("div");
            //     // Create the control.
            //     const Control = createPopOutMapBtn();
            //     ControlDiv.id = state.GridName +"_popOutMapDiv";
            //     ControlDiv.style.margin = "10px";
            //     // Append the control to the DIV.
            //     ControlDiv.appendChild(Control);
            //     map.controls[maps.ControlPosition.LEFT_BOTTOM].push(ControlDiv);
            //     setMapPopoutCreated(true);
            // }
            if(MapZoneCreated === false)
            {
                const ZoneDiv = document.createElement("div");
                // Create the control.
                const ZoneOption = createZoneMapBtn(map, maps);
                ZoneDiv.id = state.GridName +"_zoneMapDiv";
                ZoneDiv.style.margin = "10px";
                // Append the control to the DIV.
                ZoneDiv.appendChild(ZoneOption);
                map.controls[maps.ControlPosition.RIGHT_TOP].push(ZoneDiv);
                setMapZoneCreated(true);
            }

            if(MapInfoDivCreated === false && places !== null && places.length > 0 && places[0].Route !== "" && places[0].Route !== undefined)
            {
                if(MapPreviousInfoDivCreated)
                {
                    setMapPreviousInfoDivCreated(false);
                    if(map.controls[maps.ControlPosition.TOP_LEFT].length > 0)
                    {
                        map.controls[maps.ControlPosition.TOP_LEFT].removeAt(0);
                    }
                }
                // Create the control.
                const infoDiv = createMapInfoDiv(map, maps, places, []);
                map.controls[maps.ControlPosition.TOP_LEFT].push(infoDiv);
                setMapInfoDivCreated(true);
            }

            if(MapZoomCreated === false)
            {
                const ZoomDiv = document.createElement("div");
                // Create the control.
                const ZoomOption = createZoomMapBtn();
                ZoomDiv.id = state.GridName +"_zoomMapDiv";
                ZoomDiv.style.margin = "10px";
                // Append the control to the DIV.
                ZoomDiv.appendChild(ZoomOption);
                map.controls[maps.ControlPosition.RIGHT_TOP].push(ZoomDiv);
                setMapZoomCreated(true);
            }

            if(MapDepotCreated === false)
            {
                const deptDiv = document.createElement("div");
                const deptOption = createDepotBtn(map, maps);
                deptDiv.id = state.GridName + "_deptMapDiv";
                deptDiv.style.margin = "10px";

                deptDiv.appendChild(deptOption);
                map.controls[maps.ControlPosition.LEFT_BOTTOM].push(deptDiv);
                setMapDepotCreated(true);
            }

            if(MapMarkerRemovalCreated === false)
            {
                const nullifyDiv = document.createElement("div");
                const nullifyOption = createMarkerRemovalBtn(map, maps);
                nullifyDiv.id = state.GridName + "_nullifyMapDiv";
                nullifyDiv.style.margin = "10px";

                nullifyDiv.appendChild(nullifyOption);
                map.controls[maps.ControlPosition.LEFT_BOTTOM].push(nullifyDiv);
                setMapMarkerRemovalCreated(true);
            }   
            if(routeRemovalCreated === false && places !== null && places.length > 0)
            {
                const routeRemDiv = document.createElement("div");
                const routeRemDivBtn = createRouteRemovalBtn(map, maps);
                routeRemDiv.style.margin = "10px"; 

                routeRemDiv.append(routeRemDivBtn);
                map.controls[maps.ControlPosition.LEFT_BOTTOM].push(routeRemDiv);
                setRouteRemovalCreated(true);
            }

                if(props.vehData)
                {
                    const vehDiv = document.createElement("div");
                    // Create the control.
                    const VehOption = createVehTreeTable();
                    vehDiv.id = state.GridName +"_vehMapDiv";
                    vehDiv.style.margin = "10px";
                    // Append the control to the DIV.
                    vehDiv.appendChild(VehOption);
                    if(vehicleTableCreated && map.controls[maps.ControlPosition.LEFT_TOP].length > 0)
                    {
                        map.controls[maps.ControlPosition.LEFT_TOP].removeAt(0);
                        setvehicleTableCreated(false);
                    }
                    let vehInfoArr = [];
                    let vehDict = {};
                    let CloseVehCount = 0;
                    for(let f = 0; f < props.vehData.length; f++)
                    {
                        vehDict = {};
                        if(props.vehData[f].STATE !== "OFFLINE" && props.vehData[f].STATE !== "DISCONNECTED" && parseFloat(props.vehData[f].Distance) < 20)
                        {
                            CloseVehCount += 1;
                            vehDict["vehNo"] = props.vehData[f].VehNo;
                            vehDict["Dist"] = props.vehData[f].Distance;
                            vehDict["MapVehicleID"] = props.vehData[f].iVehicleID;
                            vehDict["MapDriverID"] = props.vehData[f].iDriverID;
                            vehInfoArr.push(vehDict);
                        }
                    }
                    function compare(a,b) {
                        if (a.Dist < b.Dist)
                        return -1;
                        if (a.Dist > b.Dist)
                        return 1;
                        return 0;
                    }
                    
                    
                    if(vehInfoArr.length > 0)
                    {
                        let tableBody = '<tbody style="border:1px solid black; font-size:13px;"><tr style="border-bottom:1px solid black; font-size:10px; text-align:center;"><th style="border-right:1px solid black;">Veh#('+CloseVehCount+')</th><th style="border-right:1px solid black;">Dist.</th><th>Action</th></tr>';
                        vehInfoArr.sort(compare);
                        for(let y=0; y < vehInfoArr.length; y++)
                        {
                            tableBody+="<tr style='border:1px solid black; font-size:10px; text-align:center;'><td style='border-right:1px solid black;'>"+vehInfoArr[y].vehNo+"</td><td style='border-right:1px solid black;'>"+vehInfoArr[y].Dist+"</td><td><button type='button' title='"+"Dispatch Vehicle #"+vehInfoArr[y].vehNo+"' id="+vehInfoArr[y].vehNo+"_vehicleBtn"+">Dispatch</button></td></tr>";
                        }
                        tableBody+="</tbody>";
                        if(!vehicleTableCreated)
                        {
                            map.controls[maps.ControlPosition.LEFT_TOP].push(vehDiv);
                        }
                        if(document.getElementById(state.GridName+"_vehTableTree") !== null)
                        {
                            document.getElementById(state.GridName+"_vehTableTree").innerHTML = tableBody;
                            const buttons = document.querySelectorAll('[id*="_vehTableTree"]');
                            buttons.forEach((button) => {
                                button.addEventListener("click", (e) => {
                                    let vehNo = parseInt(e.target.id.split("_")[0]);
                                    if(vehNo > 0)
                                    {
                                        document.getElementById(e.target.id).innerHTML = "<span role='status' aria-hidden='true' class='spinner-border spinner-border-sm'></span>";
                                        for (let i = 0; i < props.vehData.length; i++) {
                                            if (props.vehData[i].VehNo === String(vehNo)) {
                                              setDispatchVehicleID(props.vehData[i].iVehicleID);
                                              setDispatchDriverID(props.vehData[i].iDriverID);
                                              setinvokeDispatchComponent(true);
                                              // Break the loop if the condition is met
                                              break;
                                            }
                                        }
                                    }
                                });
                            });
                            setvehicleTableCreated(true);
                        }
                        else
                        {
                            console.log("CabDispatchTable null exp");
                        }
                        
                    }
                }
                // }
                // // console.log(places);
                // if(places.length !== 0 && places !== null)
                // {
                
                
                //setTimeout(() => {
                    
                if(places.length > 0 && places !== null)
                {
                    const bounds = getMapBounds(map, maps, places, "single");
                    if(MapInfoDivCreated)
                    {
                        if(places[0].Route !== "")
                        {
                            if(MapPreviousInfoDivCreated)
                            {
                                setMapPreviousInfoDivCreated(false);
                                if(map.controls[maps.ControlPosition.TOP_LEFT].length > 0)
                                {
                                    map.controls[maps.ControlPosition.TOP_LEFT].removeAt(0);
                                }
                            }
                            let estMilesTot = 0;
                            let estTimeTot = 0;
                            let tripCount = 0;
                            let passCount = [];
                            for(let i = 0; i < places.length; i++)
                            {
                                estMilesTot+= parseFloat(places[i].EstDistFromPrev);
                                estTimeTot+= parseFloat(places[i].EstTimeFromPrev);
                                if(places[i].Type.toUpperCase() === "PU" || places[i].Type.toUpperCase() === "DO")
                                {
                                    tripCount+=1;
                                    passCount.push(places[i].PUPerson);
                                }
                            }
                            passCount = [...new Set(passCount)];
                            tripCount = tripCount/2;
                            let content = [tripCount, estMilesTot, estTimeTot, passCount.length];
                            if(map.controls[maps.ControlPosition.TOP_LEFT].length > 0)
                            {
                                map.controls[maps.ControlPosition.TOP_LEFT].removeAt(0);
                            }
                            const infoDiv = createMapInfoDiv(map, maps, places, content); 
                            map.controls[maps.ControlPosition.TOP_LEFT].push(infoDiv);
                            
                        }
                        else
                        {
                            if(map.controls[maps.ControlPosition.TOP_LEFT].length > 0)
                            {
                                map.controls[maps.ControlPosition.TOP_LEFT].removeAt(0);
                            }
                        }
                    }
                    places.forEach((place) => {
                        if (place.Type === "PU"){

                            markers.push(new maps.Marker({
                                position: {
                                lat: parseFloat(place.dLatitude),
                                lng: parseFloat(place.dLongitude),
                                },
                                label: {text:("P"+place.iVehStopOrder), className:"fw-bold marker_label_css", name:place.TripNo},
                                map,
                                icon: place.bPerformed ? CompletedIcon:PUIcon,
                            }));
                            newPathArray.push({trip:"P", latLng: new maps.LatLng(parseFloat(place.dLatitude),parseFloat(place.dLongitude)), time: place.SchTime });
                            infowindows.push(new maps.InfoWindow({
                                content: getInfoWindowString(place, 'PU'),
                                }));

                        }

                        else if(place.Type === "DO"){
                            if(places[0].dLatitude !== null && place.dLatitude !== "" && parseFloat(place.dLatitude) !== 0){
                                if(place.bPerformed)
                                {
                                    markers.push(new maps.Marker({
                                        position: {
                                        lat: parseFloat(place.dLatitude),
                                        lng: parseFloat(place.dLongitude),
                                        },
                                        label: {text:("D"+place.iVehStopOrder), className:"fw-bold marker_label_css", name:place.TripNo},
                                        map,
                                        icon: CompletedIcon,
                                    }));
                                }
                                else
                                {
                                    markers.push(new maps.Marker({
                                        position: {
                                        lat: parseFloat(place.dLatitude),
                                        lng: parseFloat(place.dLongitude),
                                        },
                                        label: {text:("D"+place.iVehStopOrder), className:"fw-bold marker_label_css_DO", name:place.TripNo},
                                        map,
                                    }));
                                }
                                newPathArray.push({trip:"D", latLng: new maps.LatLng(parseFloat(place.dLatitude),parseFloat(place.dLongitude)), time: place.SchTime });
                                infowindows.push(new maps.InfoWindow({
                                    content: getInfoWindowString(place, 'DO'),
                                    }));

                            }

                        }
                        else if(place.Type === "StartDept" || place.Type === "StartDepot")
                        {
                            markers.push(new maps.Marker({
                                position: {
                                lat: parseFloat(place.dLatitude),
                                lng: parseFloat(place.dLongitude),
                                },
                                // icon:{text:"S", className:"fw-bold mt-1 startDepotStyle", style:"text-color:green", name:"DriverDepot"},
                                icon:SDepot,
                                map,
                            }));
                            infowindows.push(new maps.InfoWindow({
                                content: getInfoWindowString(place, 'Depot'),
                            }));
                        }
                        else if(place.Type === "EndDept" || place.Type === "EndDepot")
                        {
                            markers.push(new maps.Marker({
                                position: {
                                lat: parseFloat(place.dLatitude),
                                lng: parseFloat(place.dLongitude),
                                },
                                // label:{text:"E", className:"fw-bold mt-1 endDepotStyle", name:"DriverDepot"},
                                icon:EDepot,
                                map,
                            }));
                            infowindows.push(new maps.InfoWindow({
                                content: getInfoWindowString(place, 'Depot'),
                            }));
                        }
                        
                    });

                    if(places[0].Route === "")         //single trips
                    {
                        if(places[0].dLatitude !== null && places[0].dLatitude !== "" && parseFloat(places[0].dLatitude) !== 0 && parseFloat(places[1].dLatitude) !== 0)
                        {
                            if(addedUnroutedTrip.current && addedUnroutedTrip.current.data !== '' && additionalTrip.current !== null && additionalTrip.current.length > 0)
                            {
                                singleRoutePolylineRef.current = [];
                                if(additionalTrip.current[0].trips === undefined)       //single unrouted selected trip
                                {
                                    additionalTrip.current[0].trip.forEach((place) => {
            
                                        if (place.Type === "PU"){
                
                                            markers.push(new maps.Marker({
                                                position: {
                                                lat: parseFloat(place.dLatitude),
                                                lng: parseFloat(place.dLongitude),
                                                },
                                                label: {text:("P"), className:"fw-bold marker_label_css", name:place.TripNo},
                                                map,
                                                icon: UnroutedMarkerIcon,
                                            }));
                                            infowindows.push(new maps.InfoWindow({
                                                content: getInfoWindowString(place, 'PU'),
                                            }));
                                            bounds.extend(new maps.LatLng(
                                                parseFloat(place.dLatitude),
                                                parseFloat(place.dLongitude),
                                            ));
                
                                        }
                
                                        else if(place.Type === "DO"){
                                            if(additionalTrip.current[0].dLatitude !== null && place.dLatitude !== "" && parseFloat(place.dLatitude) !== 0){
                
                                                markers.push(new maps.Marker({
                                                    position: {
                                                    lat: parseFloat(place.dLatitude),
                                                    lng: parseFloat(place.dLongitude),
                                                    },
                                                    label: {text:("D"), className:"fw-bold marker_label_css", name:place.TripNo},
                                                    map,
                                                    icon: UnroutedMarkerDOIcon
                                                }));
                                                infowindows.push(new maps.InfoWindow({
                                                    content: getInfoWindowString(place, 'DO'),
                                                }));
                                                bounds.extend(new maps.LatLng(
                                                    parseFloat(place.dLatitude),
                                                    parseFloat(place.dLongitude),
                                                ));
                                            }
                                        }
                                    });
                                    
                                        
                                    for(let i = 0; i < PolyPaths.length; i++) {
                                        PolyPaths[i].setMap(null);
                                    }
                                    let lineDictAdditional = {latlngPU: new maps.LatLng(parseFloat(additionalTrip.current[0].trip[0].dLatitude),parseFloat(additionalTrip.current[0].trip[0].dLongitude))
                                        ,latlngDO:new maps.LatLng(parseFloat(additionalTrip.current[0].trip[1].dLatitude),parseFloat(additionalTrip.current[0].trip[1].dLongitude))};
                                    
                                    let polyPath = new maps.Polyline({
                                        path: [lineDictAdditional.latlngPU, lineDictAdditional.latlngDO],
                                        geodesic: true,
                                        strokeColor: "brown",
                                        strokeOpacity: 0.9,
                                        strokeWeight: 2,
                                    });
                                    polyPath.setMap(map);
                                    PolyPaths.push(polyPath);
                                    singleRoutePolylineRef.current.push(polyPath);
                                    setPolyPaths(PolyPaths);
                                }
                                else        //multi unrouted selected
                                {
                                    additionalTrip.current[0].trips.forEach((item) => {
                                        item.forEach((place)=>{
                                            if (place.Type === "PU"){
                
                                                markers.push(new maps.Marker({
                                                    position: {
                                                    lat: parseFloat(place.dLatitude),
                                                    lng: parseFloat(place.dLongitude),
                                                    },
                                                    label: {text:("P"), className:"fw-bold marker_label_css", name:place.TripNo},
                                                    map,
                                                    icon: UnroutedMarkerIcon,
                                                }));
                                                infowindows.push(new maps.InfoWindow({
                                                    content: getInfoWindowString(place, 'PU'),
                                                }));
                                                bounds.extend(new maps.LatLng(
                                                    parseFloat(place.dLatitude),
                                                    parseFloat(place.dLongitude),
                                                ));
                    
                                            }
                                            else if(place.Type === "DO"){
                                                if(place.dLatitude !== null && place.dLatitude !== "" && parseFloat(place.dLatitude) !== 0){
                    
                                                    markers.push(new maps.Marker({
                                                        position: {
                                                        lat: parseFloat(place.dLatitude),
                                                        lng: parseFloat(place.dLongitude),
                                                        },
                                                        label: {text:("D"), className:"fw-bold marker_label_css", name:place.TripNo},
                                                        map,
                                                        icon: UnroutedMarkerDOIcon,
                                                    }));
                                                    infowindows.push(new maps.InfoWindow({
                                                        content: getInfoWindowString(place, 'DO'),
                                                    }));
                                                    bounds.extend(new maps.LatLng(
                                                        parseFloat(place.dLatitude),
                                                        parseFloat(place.dLongitude),
                                                    ));
                                                }
                                            }
                                        });
                                    
                                    });
                                    
                                        
                                    for(let i = 0; i < PolyPaths.length; i++) {
                                        PolyPaths[i].setMap(null);
                                    }
                                    additionalTrip.current[0].trips.forEach((item) => {
                                        let lineDictAdditional = {latlngPU: new maps.LatLng(parseFloat(item[0].dLatitude),parseFloat(item[0].dLongitude))
                                            ,latlngDO:new maps.LatLng(parseFloat(item[1].dLatitude),parseFloat(item[1].dLongitude))};
                                        
                                        let polyPath = new maps.Polyline({
                                            path: [lineDictAdditional.latlngPU, lineDictAdditional.latlngDO],
                                            geodesic: true,
                                            strokeColor: "brown",
                                            strokeOpacity: 0.9,
                                            strokeWeight: 2,
                                        });
                                        polyPath.setMap(map);
                                        singleRoutePolylineRef.current.push(polyPath);
                                        PolyPaths.push(polyPath);
                                    });
                                    
                                    setPolyPaths(PolyPaths);
                                }
                                
                                let lineDict = {latlngPU: new maps.LatLng(parseFloat(places[0].dLatitude),parseFloat(places[0].dLongitude))
                                    ,latlngDO:new maps.LatLng(parseFloat(places[1].dLatitude),parseFloat(places[1].dLongitude))};
                                
                                let polyPath = new maps.Polyline({
                                    path: [lineDict.latlngPU, lineDict.latlngDO],
                                    geodesic: true,
                                    strokeColor: "black",
                                    strokeOpacity: 0.9,
                                    strokeWeight: 3,
                                });
                                polyPath.setMap(map);
                                PolyPaths.push(polyPath);
                                setPolyPaths(PolyPaths);
                            
                            }
                            else
                            {
                                for(let i = 0; i < PolyPaths.length; i++) {
                                    PolyPaths[i].setMap(null);
                                }
                                let lineDict = {latlngPU: new maps.LatLng(parseFloat(places[0].dLatitude),parseFloat(places[0].dLongitude))
                                    ,latlngDO:new maps.LatLng(parseFloat(places[1].dLatitude),parseFloat(places[1].dLongitude))};
                                
                                let polyPath = new maps.Polyline({
                                    path: [lineDict.latlngPU, lineDict.latlngDO],
                                    geodesic: true,
                                    strokeColor: "black",
                                    strokeOpacity: 0.9,
                                    strokeWeight: 3,
                                });
                                polyPath.setMap(map);
                                PolyPaths.push(polyPath);
                                setPolyPaths(PolyPaths);
                            }
                            
                        }
                    }
                    else            //multi-trips
                    {
                        if(addedUnroutedTrip.current && addedUnroutedTrip.current.data !== '' && additionalTrip.current !== null && additionalTrip.current.length > 0)
                        {
                            singleRoutePolylineRef.current = [];
                            if(additionalTrip.current[0].trips === undefined)       //single unrouted selected trip
                            {
                                additionalTrip.current[0].trip.forEach((place) => {
        
                                    if (place.Type === "PU"){
            
                                        markers.push(new maps.Marker({
                                            position: {
                                            lat: parseFloat(place.dLatitude),
                                            lng: parseFloat(place.dLongitude),
                                            },
                                            label: {text:("P"), className:"fw-bold marker_label_css", name:place.TripNo},
                                            map,
                                            icon: UnroutedMarkerIcon,
                                        }));
                                        infowindows.push(new maps.InfoWindow({
                                            content: getInfoWindowString(place, 'PU'),
                                        }));
                                        bounds.extend(new maps.LatLng(
                                            parseFloat(place.dLatitude),
                                            parseFloat(place.dLongitude),
                                        ));
            
                                    }
            
                                    else if(place.Type === "DO"){
                                        if(additionalTrip.current[0].dLatitude !== null && place.dLatitude !== "" && parseFloat(place.dLatitude) !== 0){
            
                                            markers.push(new maps.Marker({
                                                position: {
                                                lat: parseFloat(place.dLatitude),
                                                lng: parseFloat(place.dLongitude),
                                                },
                                                label: {text:("D"), className:"fw-bold marker_label_css", name:place.TripNo},
                                                map,
                                                icon: UnroutedMarkerDOIcon,
                                            }));
                                            infowindows.push(new maps.InfoWindow({
                                                content: getInfoWindowString(place, 'DO'),
                                            }));
                                            bounds.extend(new maps.LatLng(
                                                parseFloat(place.dLatitude),
                                                parseFloat(place.dLongitude),
                                            ));
                                        }
                                    }
                                });
                                
                                    
                                for(let i = 0; i < PolyPaths.length; i++) {
                                    PolyPaths[i].setMap(null);
                                }
                                let lineDictAdditional = {latlngPU: new maps.LatLng(parseFloat(additionalTrip.current[0].trip[0].dLatitude),parseFloat(additionalTrip.current[0].trip[0].dLongitude))
                                    ,latlngDO:new maps.LatLng(parseFloat(additionalTrip.current[0].trip[1].dLatitude),parseFloat(additionalTrip.current[0].trip[1].dLongitude))};
                                
                                let polyPath = new maps.Polyline({
                                    path: [lineDictAdditional.latlngPU, lineDictAdditional.latlngDO],
                                    geodesic: true,
                                    strokeColor: "brown",
                                    strokeOpacity: 0.9,
                                    strokeWeight: 2,
                                });
                                polyPath.setMap(map);
                                PolyPaths.push(polyPath);
                                singleRoutePolylineRef.current.push(polyPath);
                                setPolyPaths(PolyPaths);
                            }
                            else        //multi unrouted selected
                            {
                                additionalTrip.current[0].trips.forEach((item) => {
                                    item.forEach((place)=>{
                                        if (place.Type === "PU"){
            
                                            markers.push(new maps.Marker({
                                                position: {
                                                lat: parseFloat(place.dLatitude),
                                                lng: parseFloat(place.dLongitude),
                                                },
                                                label: {text:("P"), className:"fw-bold marker_label_css", name:place.TripNo},
                                                map,
                                                icon: UnroutedMarkerIcon,
                                            }));
                                            infowindows.push(new maps.InfoWindow({
                                                content: getInfoWindowString(place, 'PU'),
                                            }));
                                            bounds.extend(new maps.LatLng(
                                                parseFloat(place.dLatitude),
                                                parseFloat(place.dLongitude),
                                            ));
                
                                        }
                                        else if(place.Type === "DO"){
                                            if(place.dLatitude !== null && place.dLatitude !== "" && parseFloat(place.dLatitude) !== 0){
                
                                                markers.push(new maps.Marker({
                                                    position: {
                                                    lat: parseFloat(place.dLatitude),
                                                    lng: parseFloat(place.dLongitude),
                                                    },
                                                    label: {text:("D"), className:"fw-bold marker_label_css", name:place.TripNo},
                                                    map,
                                                    icon: UnroutedMarkerDOIcon,
                                                }));
                                                infowindows.push(new maps.InfoWindow({
                                                    content: getInfoWindowString(place, 'DO'),
                                                }));
                                                bounds.extend(new maps.LatLng(
                                                    parseFloat(place.dLatitude),
                                                    parseFloat(place.dLongitude),
                                                ));
                                            }
                                        }
                                    });
                                   
                                });
                                
                                    
                                for(let i = 0; i < PolyPaths.length; i++) {
                                    PolyPaths[i].setMap(null);
                                }
                                additionalTrip.current[0].trips.forEach((item) => {
                                    let lineDictAdditional = {latlngPU: new maps.LatLng(parseFloat(item[0].dLatitude),parseFloat(item[0].dLongitude))
                                        ,latlngDO:new maps.LatLng(parseFloat(item[1].dLatitude),parseFloat(item[1].dLongitude))};
                                    
                                    let polyPath = new maps.Polyline({
                                        path: [lineDictAdditional.latlngPU, lineDictAdditional.latlngDO],
                                        geodesic: true,
                                        strokeColor: "brown",
                                        strokeOpacity: 0.9,
                                        strokeWeight: 2,
                                    });
                                    polyPath.setMap(map);
                                    singleRoutePolylineRef.current.push(polyPath);
                                    PolyPaths.push(polyPath);
                                });
                                
                                setPolyPaths(PolyPaths);
                            }
                            
                
                            getStraightPolylines(newPathArray, map, maps);
                        }
                        else
                        {
                            for(let i = 0; i < PolyPaths.length; i++) {
                                PolyPaths[i].setMap(null);
                            }
                            getStraightPolylines(newPathArray, map, maps);
                        }
                        // newPathArray.sort(function(a,b){                                              //Sorted
                        //     return a.time.localeCompare(b.time);
                        // });
                        // getAPIPolyLines(newPathArray, maps);
                        
                        
                    }

                    if(props.vehData && props.vehData.length !== 0)
                    {
                        if (props.vehData.length === 1 && props.vehData.length !== 0 ) {
                            
                            if (props.vehData[0]?.ServiceStatus?.toUpperCase() !== "OFFLINE" && props.vehData[0]?.ServiceStatus?.toUpperCase() !== "DISCONNECTED") 
                            {
                                if(props.vehData[0]?.ServiceStatus?.toUpperCase() === "IRTPU" || props.vehData[0]?.ServiceStatus?.toUpperCase() === "DISPATCHED" 
                                    || props.vehData[0]?.ServiceStatus?.toUpperCase() === "ACCEPTED")
                                {
                                    markers.push(new maps.Marker({
                                        position: {
                                            lat: parseFloat(props.vehData[0].DriverLocationLatitude),
                                            lng: parseFloat(props.vehData[0].DriverLocationLongitude),
                                        },
                                        Animation: maps.Animation.DROP,
                                        icon: new maps.MarkerImage(vehImage[0], null, null, null, new maps.Size(24, 28)),
                                        map,
                                    }));
                                    infowindows.push(new maps.InfoWindow({
                                        content: getInfoWindowString(props.vehData[0], 'vehicle', true),
                                    }));
                                }
                                else
                                {
                                    if(parseFloat(props.vehData[0].EstimatedDistance) < 20)
                                    {
                                        markers.push(new maps.Marker({
                                            position: {
                                                lat: parseFloat(props.vehData[0].DriverLocationLatitude),
                                                lng: parseFloat(props.vehData[0].DriverLocationLongitude),
                                            },
                                            Animation: maps.Animation.DROP,
                                            icon: new maps.MarkerImage(vehImage[0], null, null, null, new maps.Size(24, 28)),
                                            map,
                                        }));
                                        infowindows.push(new maps.InfoWindow({
                                            content: getInfoWindowString(props.vehData[0], 'vehicle', true),
                                        }));
                                    }
                                }
                                
                                // bounds.extend(new maps.LatLng(
                                //     parseFloat(props.vehData[k].DriverLocationLatitude),
                                //     parseFloat(props.vehData[k].DriverLocationLongitude),
                                // ));
                            }
                            
                        }
                        else {
                            for(var k = 0; k < props.vehData.length; k++)
                            {
                                if(props.vehData[k].STATE !== "OFFLINE" && props.vehData[k].STATE !== "DISCONNECTED" && parseFloat(props.vehData[k].Distance) < 20)
                                {
                                    markers.push(new maps.Marker({
                                        position: {
                                            lat: parseFloat(props.vehData[k].LATITUDE),
                                            lng: parseFloat(props.vehData[k].LONGITUDE),
                                        },
                                        Animation: maps.Animation.DROP,
                                        icon: new maps.MarkerImage(vehImage[k], null, null, null, new maps.Size(24, 28)) ,
                                        map,
                                    }));
                                    infowindows.push(new maps.InfoWindow({
                                        content: getInfoWindowString(props.vehData[k], 'vehicle'),
                                    }));
                                    bounds.extend(new maps.LatLng(
                                        parseFloat(props.vehData[k].LATITUDE),
                                        parseFloat(props.vehData[k].LONGITUDE),
                                    ));
                                }
                            }
                        }
                    }
                    if(bounds && !bounds.isEmpty())
                    {
                        setTimeout(() => {
                            map.fitBounds(bounds);
                        }, 1000);
                    }
                } 
                else{           //No trip double clicked, only single click trips
                    if(singleClickUnroutedTrips.current?.data !== '' && additionalTrip.current !== null && additionalTrip.current.length > 0)
                    {
                        let bounds = null;
                        singleRoutePolylineRef.current = [];
                        if(additionalTrip.current[0].trips === undefined)       //single unrouted selected trip
                        {
                            bounds = getMapBounds(map, maps, additionalTrip.current[0].trip, "single");
                            additionalTrip.current[0].trip.forEach((place) => {
    
                                if (place.Type === "PU"){
        
                                    markers.push(new maps.Marker({
                                        position: {
                                        lat: parseFloat(place.dLatitude),
                                        lng: parseFloat(place.dLongitude),
                                        },
                                        label: {text:("P"), className:"fw-bold marker_label_css", name:place.TripNo},
                                        map,
                                        icon: UnroutedMarkerIcon,
                                    }));
                                    infowindows.push(new maps.InfoWindow({
                                        content: getInfoWindowString(place, 'PU'),
                                    }));
                                    bounds.extend(new maps.LatLng(
                                        parseFloat(place.dLatitude),
                                        parseFloat(place.dLongitude),
                                    ));
        
                                }
        
                                else if(place.Type === "DO"){
                                    if(additionalTrip.current[0].dLatitude !== null && place.dLatitude !== "" && parseFloat(place.dLatitude) !== 0){
        
                                        markers.push(new maps.Marker({
                                            position: {
                                            lat: parseFloat(place.dLatitude),
                                            lng: parseFloat(place.dLongitude),
                                            },
                                            label: {text:("D"), className:"fw-bold marker_label_css", name:place.TripNo},
                                            map,
                                            icon: UnroutedMarkerDOIcon,
                                        }));
                                        infowindows.push(new maps.InfoWindow({
                                            content: getInfoWindowString(place, 'DO'),
                                        }));
                                        bounds.extend(new maps.LatLng(
                                            parseFloat(place.dLatitude),
                                            parseFloat(place.dLongitude),
                                        ));
                                    }
                                }
                            });
                            
                                
                            for(let i = 0; i < PolyPaths.length; i++) {
                                PolyPaths[i].setMap(null);
                            }
                            let lineDictAdditional = {latlngPU: new maps.LatLng(parseFloat(additionalTrip.current[0].trip[0].dLatitude),parseFloat(additionalTrip.current[0].trip[0].dLongitude))
                                ,latlngDO:new maps.LatLng(parseFloat(additionalTrip.current[0].trip[1].dLatitude),parseFloat(additionalTrip.current[0].trip[1].dLongitude))};
                            
                            let polyPath = new maps.Polyline({
                                path: [lineDictAdditional.latlngPU, lineDictAdditional.latlngDO],
                                geodesic: true,
                                strokeColor: "brown",
                                strokeOpacity: 0.9,
                                strokeWeight: 2,
                            });
                            polyPath.setMap(map);
                            PolyPaths.push(polyPath);
                            singleRoutePolylineRef.current.push(polyPath);
                            setPolyPaths(PolyPaths);
                        }
                        else        //multi unrouted selected
                        {
                            bounds = getMapBounds(map, maps, additionalTrip.current[0].trips, "multiple");
                            additionalTrip.current[0].trips.forEach((item) => {
                                item.forEach((place)=>{
                                    if (place.Type === "PU"){
        
                                        markers.push(new maps.Marker({
                                            position: {
                                            lat: parseFloat(place.dLatitude),
                                            lng: parseFloat(place.dLongitude),
                                            },
                                            label: {text:("P"), className:"fw-bold marker_label_css", name:place.TripNo},
                                            map,
                                            icon: UnroutedMarkerIcon,
                                        }));
                                        infowindows.push(new maps.InfoWindow({
                                            content: getInfoWindowString(place, 'PU'),
                                        }));
                                        bounds.extend(new maps.LatLng(
                                            parseFloat(place.dLatitude),
                                            parseFloat(place.dLongitude),
                                        ));
            
                                    }
                                    else if(place.Type === "DO"){
                                        if(place.dLatitude !== null && place.dLatitude !== "" && parseFloat(place.dLatitude) !== 0){
            
                                            markers.push(new maps.Marker({
                                                position: {
                                                lat: parseFloat(place.dLatitude),
                                                lng: parseFloat(place.dLongitude),
                                                },
                                                label: {text:("D"), className:"fw-bold marker_label_css", name:place.TripNo},
                                                map,
                                                icon: UnroutedMarkerDOIcon,
                                            }));
                                            infowindows.push(new maps.InfoWindow({
                                                content: getInfoWindowString(place, 'DO'),
                                            }));
                                            bounds.extend(new maps.LatLng(
                                                parseFloat(place.dLatitude),
                                                parseFloat(place.dLongitude),
                                            ));
                                        }
                                    }
                                });
                            
                            });
                            
                                
                            for(let i = 0; i < PolyPaths.length; i++) {
                                PolyPaths[i].setMap(null);
                            }
                            additionalTrip.current[0].trips.forEach((item) => {
                                let lineDictAdditional = {latlngPU: new maps.LatLng(parseFloat(item[0].dLatitude),parseFloat(item[0].dLongitude))
                                    ,latlngDO:new maps.LatLng(parseFloat(item[1].dLatitude),parseFloat(item[1].dLongitude))};
                                
                                let polyPath = new maps.Polyline({
                                    path: [lineDictAdditional.latlngPU, lineDictAdditional.latlngDO],
                                    geodesic: true,
                                    strokeColor: "brown",
                                    strokeOpacity: 0.9,
                                    strokeWeight: 2,
                                });
                                polyPath.setMap(map);
                                singleRoutePolylineRef.current.push(polyPath);
                                PolyPaths.push(polyPath);
                            });
                            
                            setPolyPaths(PolyPaths);
                        }
                        if(bounds && !bounds.isEmpty())
                        {
                            setTimeout(() => {
                                map.fitBounds(bounds);
                            }, 1000);
                        }
                    }    
                }
                
                
                markers.forEach((marker, i) => {
                    oms.addMarker(marker);
                    marker.addListener('mouseover', () => {
                        infowindows[i].open(map, marker);
                    });
                    marker.addListener("mouseout", () => {
                        infowindows[i].close();
                    });
                    marker.addListener('click', ()=>{
                        try{
                            marker.setAnimation(maps.Animation.BOUNCE);
                            stopAnimation(marker);
                            for(let i = 0; i < markers.length; i++)
                            {
                                if(markers[i].label?.name === marker.label?.name && markers[i] !== marker)
                                {
                                    markers[i].setAnimation(maps.Animation.BOUNCE);
                                    stopAnimation(markers[i]);
                                }
                                else if(markers[i].label?.name !== marker.label?.name && markers[i] !== marker)
                                {
                                    markers[i].setAnimation(null);
                                }
                            }
                        }
                        catch(err){console.log(err);}
                    });

                });
                
                // map.setCenter(state.center);
                setMarkers(markers);
                // setPolyPaths(PolyPaths);
                setinfowindows(infowindows);
        }
        catch(err){console.log(err);}
        
        
        
    };

    const getStraightPolylines = (newPathArray, map, maps) =>{
        let temp1DSequence = [];
        let line = null;
        
        for(var i = 0; i < newPathArray.length; i++)
        {

            if(newPathArray[i]["trip"] === "P")
            {
                temp1DSequence.push(newPathArray[i]["trip"]);
            }
            if(i !== (newPathArray.length - 1))
            {
                
                if(newPathArray[i]["trip"] === "D")
                {
                    temp1DSequence.shift();
                    if(temp1DSequence.length === 0)
                    {
                        let lineSymbol = {
                            strokeColor: "purple",
                            path: 'M 0,-1 0,1',
                            strokeOpacity: 0.8,
                            scale: 3
                        };
                        line = new maps.Polyline({
                            path: [newPathArray[i]["latLng"], newPathArray[i+1]["latLng"]],
                            strokeOpacity: 0,
                            icons: [{
                                icon: lineSymbol,
                                offset: '10px',
                                repeat: '15px'
                            }],
                            strokeWeight: 2
                        });
                        //var ndirectionsapi = directionsapi + "origin="+fullLatLngInfo[i]["LocationInfo"].lat()+"%2C"+fullLatLngInfo[i]["LocationInfo"].lng()+"&destination="+fullLatLngInfo[i+1]["LocationInfo"].lat()+"%2C"+fullLatLngInfo[i+1]["LocationInfo"].lng()+"&AppType=GPS";
                        // await getPolyLines(ndirectionsapi, lineSymbol, 2);
                    }
                    else
                    {
                        line = new maps.Polyline({
                            path: [newPathArray[i]["latLng"], newPathArray[i+1]["latLng"]],
                            strokeColor: "black",
                            strokeOpacity: 0.9,
                            strokeWeight: 2
                        });
                        // await getPolyLines(ndirectionsapi, "", 2);
                    }
                }
                else
                {
                    line = new maps.Polyline({
                        path: [newPathArray[i]["latLng"], newPathArray[i+1]["latLng"]],
                        strokeColor: "black",
                        strokeOpacity: 0.9,
                        strokeWeight: 2
                    });
                    // await getPolyLines(ndirectionsapi, "", 2);
                }
                line.setMap(map);
                PolyPaths.push(line);
                setPolyPaths(PolyPaths);
            }
            
        }
    }

    const getAPIPolyLines = async(data, maps) => {
        let xCancelSourceForGrid = APICom.GenerateSource();
        // for(var i = 0; i < data.length; i++)
        // {
        let directionsapi = ITCMapURL+"directions?origin="+data[0]["latLng"].lat()+"%2C"+data[0]["latLng"].lng()+"&destination="+data[1]["latLng"].lat()+"%2C"+data[1]["latLng"].lng()+"&AppType=GPS";
        var myHeaders = new Headers();
            myHeaders.append("Authorization", "Basic "+btoa(OSRM_Username + ":" + OSRM_Password));
        await APICom.fetchData("full", directionsapi, "get", myHeaders, data).then((response) => {
            // var encrptedpolylines = response.data["routes"]["0"]["overview_polyline"]["points"];
            // console.log(response.data);
            // decrpytpoly(encrptedpolylines);
        });
        // }
        
        
    }

    const decrpytpoly = (encrptedpolylines) => {

        var polyline = {};
      
        polyline.decode = function(str, precision) {
            var index = 0,
                lat = 0,
                lng = 0,
                coordinates = [],
                shift = 0,
                result = 0,
                byte = null,
                latitude_change,
                longitude_change,
                factor = Math.pow(10, Number.isInteger(precision) ? precision : 5);
      
            // Coordinates have variable length when encoded, so just keep
            // track of whether we've hit the end of the string. In each
            // loop iteration, a single coordinate is decoded.
            while (index < str.length) {
      
                // Reset shift, result, and byte
                byte = null;
                shift = 0;
                result = 0;
      
                do {
                    byte = str.charCodeAt(index++) - 63;
                    result |= (byte & 0x1f) << shift;
                    shift += 5;
                } while (byte >= 0x20);
      
                latitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));
      
                shift = result = 0;
      
                do {
                    byte = str.charCodeAt(index++) - 63;
                    result |= (byte & 0x1f) << shift;
                    shift += 5;
                } while (byte >= 0x20);
      
                longitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));
      
                lat += latitude_change;
                lng += longitude_change;
      
                coordinates.push([lat / factor, lng / factor]);
            }
      
            return coordinates;
        };
      
      
        var decryptedpolylines = polyline.decode(encrptedpolylines);
        var polycoord = [];
        for(var i = 0; i < decryptedpolylines.length; i++){
    
        var latlong = {};
        latlong["lat"] = decryptedpolylines[i][0];
        latlong["lng"] = decryptedpolylines[i][1];
        //console.log(latlong);
        polycoord.push(latlong);
        }
        
        return polycoord;
    }

    const RemoveAllMapObjects = () => {
        if(!keepZoneRef.current){
            for(let i = 0; i < polygons.length; i++) {
                polygons[i].setMap(null);
            }
        }
        for(let i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }
        for(let i = 0; i < PolyPaths.length; i++) {
            PolyPaths[i].setMap(null);
        }
        for(let i = 0; i < infowindows.length; i++) {
            infowindows[i].setMap(null);
        }
        
    }

    useEffect( () => {
        window.addEventListener('resize', handleResize);
        // window.addEventListener('beforeunload', localStorage.removeItem("placeInfo"));
        return() => {
            RemoveAllMapObjects();
            // window.removeEventListener('beforeunload', localStorage.removeItem("placeInfo"));
        };
    }, []);
    

    
    return(
         <Col xs={12} id={state.GridName + '_mapContainer'} style={{ ...dynamicHeight, height: `calc(${props.height} - 5px)`, padding: 0 }}>
            <GoogleMapReact bootstrapURLKeys={{key:'AIzaSyCUZiQELkgLvz9RFYDCl4Lsetn3H54jaXI'}} yesIWantToUseGoogleMapApiInternals 
                defaultCenter={state.center} defaultZoom={state.zoom} tilt={state.tilt} mapId={state.mapId} options={{gestureHandling: state.options.gestureHandling, 
                    zoomControl: zoomOpt.zoomControl, fullscreenControl: true, streetViewControl:true, mapTypeControl:true, draggable: zoomOpt.draggable, scrollwheel: zoomOpt.scrollWheel, disableDoubleClickZoom: zoomOpt.disableDoubleClickZoom}} 
                onGoogleApiLoaded={({ map, maps }) => { 
                    handleApiLoaded(map, maps, state.places)
                    setGlobalMapsObjects({map:map, maps:maps});
                    map.setCenter(mapCenterRef.current);
                }
                }>
                    
            </GoogleMapReact>
            {invokeDispatchComponent? (<DispatchAction GridRowData={props.GridRowData} selectedDriver={dispatchDriverID} selectedVehicle={dispatchVehicleID} 
            DispatchVehicleData={props.DispatchVehicleData} DispatchDriverData={props.DispatchDriverData} chkVehicleRequiredRef={false}
            invokeDispatchComponent={invokeDispatchComponent} setinvokeDispatchComponent={UnmountDispatchActionComponent}/>) : ""}
        </Col>
            
    );
};

export default MapControl;